import { useState,useEffect  } from "react";
import { Link,useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom/dist/umd/react-router-dom.development";
import { useEditableContent } from "../../Context/EditableContentContext";
import { useDispatch, useSelector } from "react-redux";
import { setTitle } from "../../redux/titleSlice";

const PackageHeader = ({ toggleSidebar }) => {
  const { packageId } = useParams();
  const { editablePackageContent, handlePackageContentChange } =
    useEditableContent();
  const [isEditing, setIsEditing] = useState(false);
  const [newContent, setNewContent] = useState(editablePackageContent);

 const title = useSelector((state) => state.title.title);
  const dispatch = useDispatch();

 const navigate = useNavigate();

  // const handleInputChange = (e) => {
  //   setNewContent(e.target.value);
  // };

  // const handleKeyPress = (e) => {
  //   if (e.key === "Enter") {
  //     updatePackage();
  //     setIsEditing(false);
  //   }
  // };

const handleTitleClick = (e) => {
    e.preventDefault();
    setIsEditing(true);
  };

  // const handleClick = () => {
  //   setIsEditing(true);
  // };

  // const handleBlur = () => {
  //   updatePackage();
  //   setIsEditing(false);
  // };

  // const updatePackage = async () => {
  //   try {
  //     const response = await axios.post(
  //       `${process.env.REACT_APP_BACKEND_URL}/api/packages/${packageId}/edit`,
  //       {
  //         name: newContent,
  //         // Add other fields as needed
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );
  //     Swal.fire({
  //       icon: "success",
  //       title: "Success",
  //       text: "Package updated successfully!",
  //     });
  //     handlePackageContentChange(newContent);
  //   } catch (error) {
  //     console.error("Error updating package:", error);
  //   }
  // };
 const handleTitleChange = (e) => {
    dispatch(setTitle(e.target.value));
  };

  const handleBlur = () => {
    setIsEditing(false);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      setIsEditing(false);
    }
  };

  useEffect(() => {
      
      dispatch(setTitle('Package'));
  
    }, []);

  return (
   <nav className='navbar navbar-expand nav_mobile flex-column flex-md-row bottom-header-main px-lg-5 px-2 py-2'>
      <div className='d-flex align-items-center d-md-flex ms-md-2'>
        <div className='d-flex align-items-center bottom-header'>
          {/* ====== Hamburger Button to Toggle The side Bar =========== */}
           <button
            className='sidebar-toggler flex-shrink-0 bg-transparent border-0 me-3'
            onClick={toggleSidebar}>
            <i className='fa fa-bars' />
          </button>

          <Link to='/templates' onClick={(e) => e.preventDefault()}>
            <div className='title-container' onClick={handleTitleClick}>
              {/* Title */}
              {/* {isEditing ? (
                <input
                  type='text'
                  value={title}
                  onChange={handleTitleChange}
                  onBlur={handleBlur}
                  onKeyPress={handleKeyPress}
                  autoFocus
                  className='editable-title'
                />
              ) : ( */}
                <h5 className='untitled-product-title'>Package</h5>
              {/* )} */}
            </div>
            {/* Folder icon and preview text */}
            <p className='d-flex align-items-center'>
              <i className='far fa-folder'></i>
              <span className='preview-text'>Templates</span>
            </p>
          </Link>
        </div>
      </div>
      {/* <div className='navbar-nav align-items-center ms-md-auto'>
        <div className='py-3 button_group gy-3'>
          <button className='bg-white'>PREVIEW</button>
          <button>USE TEMPLATE</button>
        </div>
      </div> */}
    </nav>

  );
};

export default PackageHeader;
